var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-box",on:{"click":_vm.go}},[_c('p',[_vm._v("洛阳市儿童救助保护综合服务平台")])])
}
var staticRenderFns = []

export { render, staticRenderFns }